import React, { ReactElement, useState } from 'react';
import PracovneKroky from './PracovneKroky';
import './pracovneKrokyButton.scss';
import LegislativnyMaterialItem from '../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import Dropdown from '../../../../Dropdown/Dropdown';
import PracovnyKrokListRequest from '../../../../../model/pracovnyKrok/PracovnyKrokListRequest';
import { ClientStatus } from '../../../../../model/ClientStatus';
import StadiumMaterialuHistoria
  from '../../../../../model/legislativnyMaterial/StadiumMaterialuHistoria';

interface Props {
  material: LegislativnyMaterialItem;
  reloadMaterial: () => void;
  pracovneKrokyRequest: PracovnyKrokListRequest;
  pracovneKrokyStatus: ClientStatus;
  reloadPracovneKroky;
  historiaRecords?: Array<StadiumMaterialuHistoria>;
}

const PracovneKrokyButton = ({
  material,
  reloadMaterial,
  pracovneKrokyRequest,
  pracovneKrokyStatus,
  reloadPracovneKroky,
  historiaRecords,
}: Props): ReactElement => {
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  if (pracovneKrokyRequest?.pracovneKroky?.length < 1) {
    return null;
  }

  return (
    <div className="material-detail-pracovne-kroky__button">
      <Dropdown
        title="Pracovné kroky"
        loading={pracovneKrokyStatus?.loading}
        isDropdownOpened={isDropdownOpened}
        setIsDropdownOpened={setIsDropdownOpened}
      >
        <PracovneKroky
          legMaterial={material}
          pracovneKroky={pracovneKrokyRequest}
          reloadPracovneKroky={reloadPracovneKroky}
          reloadDetail={reloadMaterial}
          setIsDropdownOpened={setIsDropdownOpened}
          historiaRecords={historiaRecords}
        />
      </Dropdown>
    </div>
  );
};

export default PracovneKrokyButton;
